"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textSingleLineStyles = void 0;
var tslib_1 = require("tslib");
var appStylesBase_1 = require("../appStylesBase");
var emotion_1 = require("emotion");
var textSingleLineStyles = function () { return (0, emotion_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  line-height: ", ";\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  line-height: ", ";\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])), (0, appStylesBase_1.appStylesBase)().lineHeight.medium); };
exports.textSingleLineStyles = textSingleLineStyles;
var templateObject_1;
